<template>
  <div class="match-2021p">
    <div style="min-width: 1160px; position: relative">
      <el-row
        class="bannerP-0204"
        onclick='javascript:window.open("http://univ.ciciec.com/col.jsp?id=116","_blank")'
      >
      </el-row>
      <el-row class="pd60-0204 ssjj-wrapper" id="ssjj-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">赛事简介</el-row>
          <el-row class="title-bgimg-0204" style="margin-bottom: 30px"></el-row>
          <el-row class="ssjj-content">
            <div class="ssjj-bgimg"></div>
            <div class="ssjj-text font14-0204">
              <p class="mgb10-0204">
                2021年1月中旬，海云捷迅及重庆邮电大学执行承办的第五届全国大学生集成电路创新创业大赛启动仪式在西部（重庆）科学城举行。该活动由工业和信息化部人才交流中心主办，重庆高新技术产业开发区管理委员会承办，重庆西永微电子产业园区、重庆高新区创新服务中心、示范性微电子学院产学融合发展联盟、IEEE中国代表处、北京电子学会协办。
              </p>
              <p>
                作为本次大赛中的执行承办方，海云捷迅将提供人工智能边缘实验平台作为本次大赛的赛事平台，并参与赛题设置。海云捷迅将倾力参与到大赛中，为参赛团队提供服务。
              </p>
            </div>
          </el-row>
        </el-row>
      </el-row>

      <el-row class="pd60-0204" id="jczx-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204" style="color: #fff"
            >精彩资讯</el-row
          >
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="title-text-0204" style="color: #d9d9d9"
            >实时传递大赛最新动态</el-row
          >
          <div style="display: flex">
            <div class="lbt-btn">
              <i class="icon iconfont icon-fj-chevron-left"></i>
            </div>
            <div class="swiper-container" style="margin: 0 10px">
              <div class="swiper-wrapper">
                <!-- 2021-11-1 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4620','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021110101-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="携手“集创赛”走近高校，海云捷迅助力产教融合"
                      >
                        携手“集创赛”走近高校，海云捷迅助力产教融合
                      </div>
                      <div class="date">2021-10-29</div>
                      <div
                        class="description"
                        title="海云捷迅将持续支持并参与集创赛的相关赛事，深化产教融合。同时也会继续深耕FPGA等核心技术，提供辐射全国的技术支持、人才培养、市场推动、渠道与产业对接等全方面服务，进而打造FPGA领域的技术高地和产业高地"
                      >
                        海云捷迅将持续支持并参与集创赛的相关赛事，深化产教融合。同时也会继续深耕FPGA等核心技术，提供辐射全国的技术支持、人才培养、市场推动、渠道与产业对接等全方面服务，进而打造FPGA领域的技术高地和产业高地
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 2021-10-22 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4592','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021102207-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼在重庆举行"
                      >
                        第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼在重庆举行
                      </div>
                      <div class="date">2021-10-20</div>
                      <div class="description">
                        第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼在重庆举行
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4583','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021102206-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼即刻上演"
                      >
                        第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼即刻上演
                      </div>
                      <div class="date">2021-10-16</div>
                      <div class="description">
                        第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼即刻上演
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4533','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021102205-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="海云捷迅——为集成电路行业提供更有效的解决方案"
                      >
                        海云捷迅——为集成电路行业提供更有效的解决方案
                      </div>
                      <div class="date">2021-10-15</div>
                      <div class="description">
                        海云捷迅为集成电路行业提供更有效的解决方案
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4574','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021102204-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼活动日程"
                      >
                        第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼活动日程
                      </div>
                      <div class="date">2021-10-13</div>
                      <div class="description">
                        第五届集创赛“海云捷迅杯”全国总决赛颁奖典礼活动日程
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4569','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021102203-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛全国总决赛奖金领取说明"
                      >
                        第五届集创赛全国总决赛奖金领取说明
                      </div>
                      <div class="date">2021-09-10</div>
                      <div class="description">
                        第五届集创赛全国总决赛奖金领取说明
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4540','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021102202-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛全国总决赛获奖名单公布"
                      >
                        第五届集创赛全国总决赛获奖名单公布
                      </div>
                      <div class="date">2021-09-10</div>
                      <div class="description">
                        第五届集创赛全国总决赛获奖名单公布
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4536','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2021102201-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title" title="第五届集创赛获奖证书电子版查询">
                        第五届集创赛获奖证书电子版查询
                      </div>
                      <div class="date">2021-09-10</div>
                      <div class="description">
                        第五届集创赛获奖证书电子版查询
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2021-09-24 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4513','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/ai-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title" title="海云捷迅杯再助AI教育落地走实">
                        海云捷迅杯再助AI教育落地走实
                      </div>
                      <div class="date">2021-9-22</div>
                      <div class="description">
                        海云捷迅杯再助AI教育落地走实
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4495','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/club-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="海云捷迅杯企业大奖获奖团队爱卡丝俱乐部"
                      >
                        海云捷迅杯企业大奖获奖团队爱卡丝俱乐部
                      </div>
                      <div class="date">2021-9-15</div>
                      <div class="description">
                        海云捷迅杯企业大奖获奖团队爱卡丝俱乐部
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2021-09-14 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4488','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/cup-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="海云捷迅推动集成电路产学合作发展"
                      >
                        海云捷迅推动集成电路产学合作发展
                      </div>
                      <div class="date">2021-9-13</div>
                      <div class="description">
                        海云捷迅携手集创赛，通过总决赛的执行承办，搭建起地方，全国高校以及行业企业之间的沟通桥梁，为重庆高新区集成电路聚集专业人才，为全国集成电路产业发展助力。
                      </div>
                      <!-- <div class="description"><br/></div> -->
                    </div>
                  </div>
                </div>
                <!-- 2021-09-02增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4466','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/finals-cq-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="“海云捷迅杯”全国总决赛在重庆举行"
                      >
                        “海云捷迅杯”全国总决赛在重庆举行
                      </div>
                      <div class="date">2021-9-01</div>
                      <div class="description">
                        “海云捷迅杯”全国总决赛在重庆举行
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2021-08-31增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4446','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/three-foreshow-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“海云捷迅杯”全国总决赛直播厅第三天节目预告"
                      >
                        第五届集创赛“海云捷迅杯”全国总决赛直播厅第三天节目预告
                      </div>
                      <div class="date">2021-8-27</div>
                      <div class="description">
                        第五届集创赛“海云捷迅杯”全国总决赛直播厅第三天节目预告
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4442','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/two-foreshow-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“海云捷迅杯”全国总决赛直播厅第二天节目预告"
                      >
                        第五届集创赛“海云捷迅杯”全国总决赛直播厅第二天节目预告
                      </div>
                      <div class="date">2021-8-26</div>
                      <div class="description">
                        第五届集创赛“海云捷迅杯”全国总决赛直播厅第二天节目预告
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4426','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2-finals-20210824-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="延期通知—集创赛五周年短视频大赛继续征集"
                      >
                        延期通知—集创赛五周年短视频大赛继续征集
                      </div>
                      <div class="date">2021-8-26</div>
                      <div class="description">
                        征集时间（变更）：由原来8月25号18:00截止，延期到8月27号18:00截止
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4433','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/one-foreshow-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“海云捷迅杯”全国总决赛 直播厅第一天节目预告"
                      >
                        第五届集创赛“海云捷迅杯”全国总决赛 直播厅第一天节目预告
                      </div>
                      <div class="date">2021-8-25</div>
                      <div class="description">
                        第五届集创赛“海云捷迅杯”全国总决赛 直播厅第一天节目预告
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4417','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2-finals-20210824-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="参赛有奖—集创赛五周年短视频大赛火热征集中"
                      >
                        参赛有奖—集创赛五周年短视频大赛火热征集中
                      </div>
                      <div class="date">2021-8-19</div>
                      <div class="description">
                        集创赛五周年短视频大赛火热征集中。
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4413','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/5-finals-20210824-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛分赛区决赛获奖证书电子版查询"
                      >
                        第五届集创赛分赛区决赛获奖证书电子版查询
                      </div>
                      <div class="date">2021-8-18</div>
                      <div class="description">
                        分赛区决赛获奖证书电子版查询。
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4410','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/4-finals-20210824-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛全国总决赛杯赛答辩及作品提交要求"
                      >
                        第五届集创赛全国总决赛杯赛答辩及作品提交要求
                      </div>
                      <div class="date">2021-8-17</div>
                      <div class="description">
                        总决赛杯赛答辩及作品提交要求。
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4404','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/3-finals-20210824-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title">
                        第五届集创赛全国总决赛参赛补充说明
                      </div>
                      <div class="date">2021-8-12</div>
                      <div class="description">
                        第五届集创赛全国总决赛将采取线上答辩的形式，各团队于2021年8月26日—28日参加线上答辩、企业宣讲等活动。
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4399','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/2-finals-20210824-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="芯动有你，青春逐梦 集创赛五周年抖音短视频大赛"
                      >
                        芯动有你，青春逐梦 集创赛五周年抖音短视频大赛
                      </div>
                      <div class="date">2021-8-12</div>
                      <div class="description">
                        集创赛五周年短视频大赛火热征集中。
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4390','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/1-finals-20210824-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛总决赛线上答辩操作指引【附总决赛答辩顺序】"
                      >
                        第五届集创赛总决赛线上答辩操作指引【附总决赛答辩顺序】
                      </div>
                      <div class="date">2021-8-12</div>
                      <div class="description">
                        总决赛线上答辩操作指引【附总决赛答辩顺序】。
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4370','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/zongjuesai-0811.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="关于第五届集创赛全国总决赛参赛事项的通知"
                      >
                        关于第五届集创赛全国总决赛参赛事项的通知
                      </div>
                      <div class="date">2021-8-10</div>
                      <div class="description">
                        第五届集创赛全国总决赛将于2021年8月26日-28日在线上举行
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4361','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/mingyuanbei-0811-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“晶丰明源杯”华东分赛区决赛圆满完成【附获奖名单】"
                      >
                        第五届集创赛“晶丰明源杯”华东分赛区决赛圆满完成【附获奖名单】
                      </div>
                      <div class="date">2021-8-6</div>
                      <div class="description">
                        “晶丰明源杯”华东分赛区决赛圆满完成
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4347','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/xinhaibei-0811.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title">
                        第五届集创赛“芯海杯”
                        华中分赛区决赛圆满完成【附获奖名单】
                      </div>
                      <div class="date">2021-7-30</div>
                      <div class="description">
                        第五届集创赛“芯海杯” 华中分赛区决赛圆满完成
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4331','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/06-finals-8-2-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛华东分赛区决赛参赛事项的补充通知【附答辩安排】"
                      >
                        第五届集创赛华东分赛区决赛参赛事项的补充通知【附答辩安排】
                      </div>
                      <div class="date">2021-7-29</div>
                      <div class="description">
                        华东分赛区决赛参赛事项的补充通知
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4315','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/05--finals-8-2-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛“芯海杯”华南分赛区决赛圆满完成【附获奖名单】"
                      >
                        第五届集创赛“芯海杯”华南分赛区决赛圆满完成【附获奖名单】
                      </div>
                      <div class="date">2021-7-28</div>
                      <div class="description">
                        “芯海杯”华南分赛区决赛圆满完成
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4313','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/04-online-finals-8-2-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="关于第五届集创赛华东分赛区决赛改为线上举行的紧急通知"
                      >
                        关于第五届集创赛华东分赛区决赛改为线上举行的紧急通知
                      </div>
                      <div class="date">2021-7-27</div>
                      <div class="description">华东分赛区决赛改为线上举行</div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4311','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/03-onlinefinals-8-2-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title">
                        关于第五届集创赛华中分赛区决赛改为线上举行的紧急通知
                      </div>
                      <div class="date">2021-7-26</div>
                      <div class="description">华中分赛区决赛改为线上举行</div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4303','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/02-finals-8-2-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛华中分赛区决赛参赛事项的补充通知【附答辩安排】"
                      >
                        第五届集创赛华中分赛区决赛参赛事项的补充通知【附答辩安排】
                      </div>
                      <div class="date">2021-7-26</div>
                      <div class="description">
                        华中分赛区决赛参赛事项的补充通知
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4267','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/08-southwest-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛西南分赛区决赛答辩安排"
                      >
                        第五届集创赛西南分赛区决赛答辩安排
                      </div>
                      <div class="date">2021-7-19</div>
                      <div class="description">西南分赛区决赛答辩安排。</div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4263','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/07-Southwest-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛西南分赛区决赛参赛通知"
                      >
                        第五届集创赛西南分赛区决赛参赛通知
                      </div>
                      <div class="date">2021-7-9</div>
                      <div class="description">西南分赛区决赛参赛通知。</div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4296','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/01-finals-8-2-340.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛东北分赛区决赛通知暨创新发展线上论坛"
                      >
                        第五届集创赛东北分赛区决赛通知暨创新发展线上论坛
                      </div>
                      <div class="date">2021-7-7</div>
                      <div class="description">
                        东北分赛区决赛通知暨创新发展线上论坛
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4272','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/06-Division-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛分赛区决赛 杯赛答辩要求"
                      >
                        第五届集创赛分赛区决赛 杯赛答辩要求
                      </div>
                      <div class="date">2021-7-6</div>
                      <div class="description">
                        第五届集创赛分赛区决赛 杯赛答辩要求。
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4258','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/05-Division-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛分赛区决赛参赛相关问题答疑"
                      >
                        第五届集创赛分赛区决赛参赛相关问题答疑
                      </div>
                      <div class="date">2021-7-5</div>
                      <div class="description">
                        参赛队伍必看，分赛区决赛参赛相关补充说明。
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4251','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/04-Promotion-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛初赛晋级名单公示通知"
                      >
                        第五届集创赛初赛晋级名单公示通知
                      </div>
                      <div class="date">2021-7-2</div>
                      <div class="description">
                        第五届全国大学生集成电路创新创业大赛初赛晋级名单已公示。
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4240','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/03-Preliminaries2-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title" title="初赛通知-附件2：提交格式及要求">
                        初赛通知-附件2：提交格式及要求
                      </div>
                      <div class="date">2021-5-26</div>
                      <div class="description">
                        第五届集创赛初赛通知，附件2：提交格式及要求
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4243','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/02-Preliminaries1-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="初赛通知-附件1：阶段报告及杯赛题目作品要求"
                      >
                        初赛通知-附件1：阶段报告及杯赛题目作品要求
                      </div>
                      <div class="date">2021-5-26</div>
                      <div class="description">
                        第五届集创赛初赛通知-附件1：阶段报告及海云捷迅杯赛题目作品要求
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4234','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/01-Preliminaries-340_20210721.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div class="title" title="第五届集创赛初赛通知">
                        第五届集创赛初赛通知
                      </div>
                      <div class="date">2021-5-26</div>
                      <div class="description">
                        第五届集创赛即将进入初赛阶段，大赛组委会拟于6月举办初赛。初赛需要提交的材料分为阶段报告和杯赛题目作品两部分。
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4130','_blank')"
                  >
                    <div class="top">
                      <img src="@/assets/myMatch/2021p/jingcaizixun.jpg" />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="2021集成电路产教融合高峰论坛重磅开启！"
                      >
                        2021集成电路产教融合高峰论坛重磅开启！
                      </div>
                      <div class="date">2021-5-8</div>
                      <div class="description">
                        5月14日至16日在重庆市举办“2021全国集成电路产教融合高峰论坛”。本次高峰论坛主题为“构建集成电路产教融合新生态，推动一级学科建设与人才培养”。
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4050','_blank')"
                  >
                    <div class="top">
                      <img src="@/assets/myMatch/2021p/重要通知20210316.jpg" />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="关于延迟第五届集创赛报名截止时间的通知"
                      >
                        关于延迟第五届集创赛报名截止时间的通知
                      </div>
                      <div class="date">2021-3-15</div>
                      <div class="description">
                        第五届全国大学生集成电路创新创业大赛报名截止时间延至2021年3月31日24:00
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4036','_blank')"
                  >
                    <div class="top">
                      <img src="@/assets/myMatch/2021p/7点20210310.jpg" />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="海云捷迅杯赛，不得不说的7个“知识点”"
                      >
                        海云捷迅杯赛，不得不说的7个“知识点”
                      </div>
                      <div class="date">2021-3-9</div>
                      <div class="description">
                        云上芯探索
                        AI谱未来，海云捷迅助力集成电路创新开启。第五届全国大学生集成电路创新创业大赛-海云捷迅杯赛，不得不说的7个“知识点”
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4030','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/2021p/倒计时10天20210310.jpg"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="倒计时10天！第五届集创赛喊你来报名！"
                      >
                        倒计时10天！第五届集创赛喊你来报名！
                      </div>
                      <div class="date">2021-3-5</div>
                      <div class="description">
                        由海云捷迅作为企业代表参与赛题设置的海云捷迅杯在FPGA设计与应用赛道静待大家参与，其赛题为《基于FPGA
                        C5Soc的MobileNetV1
                        SSD目标检测方案设计》，第五届集创赛海云捷迅杯官网已正式上线
                      </div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=3986','_blank')"
                  >
                    <div class="top">
                      <img src="@/assets/myMatch/2021p/jczx0204_1.jpg" />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="FPGA+AI双剑合璧—海云捷迅杯助你练就正宗芯法"
                      >
                        FPGA+AI双剑合璧—海云捷迅杯助你练就正宗芯法
                      </div>
                      <div class="date">2021-2-8</div>
                      <div class="description">
                        海云捷迅杯赛，将FPGA与AI应用双剑合璧， Intel FPGA
                        C5Soc，SSD模型框架，CNN加速，百度paddle-paddle框架等众多关键技术与平台融于一体，助你练就人工智能时代正宗芯法，成为直面前沿挑战的弄潮儿。
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=3973','_blank')"
                  >
                    <div class="top">
                      <img src="@/assets/myMatch/2021p/jczx0204_2.jpg" />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="扛起人工智能教育大旗——海云捷迅执行承办第五届全国大学生集成电路创新创业大赛"
                      >
                        扛起人工智能教育大旗——海云捷迅执行承办第五届全国大学生集成电路创新创业大赛
                      </div>
                      <div class="date">2021-1-29</div>
                      <div class="description">
                        2021年1月中旬，海云捷迅及重庆邮电大学执行承办的第五届全国大学生集成电路创新创业大赛启动仪式在西部（重庆）科学城举行。
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4001','_blank')"
                  >
                    <div class="top">
                      <img src="@/assets/myMatch/2021p/jczx0204_3.jpg" />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第五届集创赛启动仪式在重庆市举行"
                      >
                        第五届集创赛启动仪式在重庆市举行
                      </div>
                      <div class="date">2021-1-15</div>
                      <div class="description">
                        1月12日第五届全国大学生集成电路创新创业大赛
                        启动仪式在重庆市举行。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lbt-btn">
              <i class="icon iconfont icon-fj-chevron-right"></i>
            </div>
          </div>
        </el-row>
      </el-row>

      <div id="awcloudCup">
        <div class="awcloudCup_center">
          <!-- 大赛培训 -->
          <div>
            <div class="awcloudCompetTrain_wrap">
              <div class="awcloudCup_title">
                <div class="awcloudCup_titleTop">
                  <div class="title-font28-0204">大赛培训</div>
                  <div class="awcloudCup_titleImg"></div>
                </div>
              </div>

              <div class="awcloudCompetTrain_content">
                <dl>
                  <dt>
                    <img
                      src="@/assets/myMatch/2021p/dasaipeixun_img.jpg"
                      alt=""
                    />
                  </dt>
                  <dd>
                    <h3 class="awcloudCompetTrain_title">
                      第五届全国大学生集成电路创新创业大赛——线上宣讲会
                    </h3>
                    <p class="awcloudCompetTrain_Sessions">
                      集创赛赛前宣讲第四场——FPGA设计与应用赛道
                    </p>
                    <p class="awcloudCompetTrain_number">
                      2347 人次学习 直播时间： 2021.03.01 14：00:00
                    </p>
                  </dd>
                </dl>
              </div>
              <div class="awcloudCompetTrain_buttonBox">
                <button
                  class="awcloudCompetTrain_button"
                  onclick="javascript:window.open('https://appuyuimady2642.pc.xiaoe-tech.com/detail/l_6038b2e2e4b0b6e9418e12a2/4?from=p_600fb791e4b0f176aecb0283&type=8','_blank')"
                >
                  进入回看
                </button>
                <div class="awcloudCompetTrain_free">免费</div>
              </div>
            </div>
            <!-- 
                    相关课程持续更新
                -->
            <div class="awcloudCompetTrain_course">
              <img
                src="@/assets/myMatch/2021p/dasaipeixun_dot_left.png"
                alt=""
              />
              <p>第五届集创赛培训相关课程持续更新ing,敬请关注!</p>
              <img
                src="@/assets/myMatch/2021p/dasaipeixun_dot_right.png"
                alt=""
              />
            </div>
          </div>

          <!-- 海云捷迅杯 -->
          <div class="awcloudCup_title">
            <div class="awcloudCup_titleTop">
              <!-- <h2>海云捷迅杯</h2> -->
              <div class="title-font28-0204">海云捷迅杯</div>
              <div class="awcloudCup_titleImg"></div>
            </div>
            <div class="awcloudCup_titleBottom">
              海云捷迅作为企业代表参与赛题设置，大赛中开设"海云捷迅杯"赛道
            </div>
          </div>
          <!-- 杯赛题目 -->
          <div class="awcloudCup_subject">
            <ul class="awcloudCup_subjectTop">
              <li class="awcloudCup_subjectTopLeft">
                <div class="awcloudCup_subjectImg"></div>
                <h3 class="awcloudCup_subjectTitle">杯赛题目</h3>
              </li>
              <li class="awcloudCup_subjectTopRight">
                <div class="awcloudCup_subjectImg"></div>
                <h3 class="awcloudCup_subjectTitle">参赛组别</h3>
              </li>
            </ul>
            <ul class="awcloudCup_subjectBottom">
              <li class="awcloudCup_subjectBottomLeft">
                基于FPGA C5Soc的MobileNetV1 SSD目标检测方案设计
              </li>
              <li class="awcloudCup_subjectBottomRight">
                <h3>B组</h3>
              </li>
            </ul>
          </div>
          <!-- 设计任务 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>设计任务</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>
                1. 基于已训练好的SSD模型参数文件、基于已有的Intel
                FPGA工程网表文件、Linux-C5soc平台的Paddle-Paddle框架驱动为参考，优化或者重新设计加速器以及对应驱动，并部署SSD模型到FPGA进行推理
              </li>
              <li>2. 对方案进行评估和实现</li>
              <li>3. 提出设计方案，提升性能并实现</li>
              <li>4. 基础部分100，附加部分40分。最后总分按两部分相加得到</li>
              <li>
                备注：SSD模型参数文件、工程网表文件，包括整个工程结构顶层以及各模块连接关系，包括卷积、全连接等算子以及互联矩阵、调度模块等CNN加速器的完整工程。
              </li>
            </ul>
          </div>
          <!-- 设计指标 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>设计指标</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>1. 模型部署完成，能正确识别图片数据，推理时间1s以内</li>
              <li>2. 完成方案设计，完成方案设计文稿</li>
            </ul>
          </div>
          <!-- 附加题 -->
          <div class="awcloudCup_task" style="padding-bottom: 45px">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>附加题</div>
            </el-row>
            <ul class="awcloudCup_taskBottom" style="padding-bottom: 0">
              <li style="margin-bottom: 0">
                根据提供的网表和驱动文件，根据Demo工程重新设计加速器底层Verilog工程结构及相应驱动
              </li>
            </ul>
            <div class="awcloudCup_taskBottomTable">
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_taskBottomPerformance">
                      性能/帧率(FPS)
                    </th>
                    <th class="awcloudCup_taskBottomScore">分值</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>16</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>20</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>22</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>24</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>26</td>
                  </tr>
                </tbody>
              </table>
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_taskBottomPerformance">
                      性能/帧率(FPS)
                    </th>
                    <th class="awcloudCup_taskBottomScore">分值</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>9</td>
                    <td>28</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>30</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>32</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>34</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>36</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>38</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>40</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 提交内容 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>提交内容</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>1. 汇报PPT：项目介绍、关键技术介绍、性能指标</li>
              <li>2. 详细设计方案：系统架构分析、关键技术分析、性能分析</li>
              <li>3. 驱动源码以及底层Verilog工程源码、仿真以及测试报告</li>
            </ul>
          </div>
          <!-- 评分标准 -->
          <div
            class="awcloudCup_task"
            style="margin-bottom: 0; padding-bottom: 45px"
          >
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>评分标准</div>
            </el-row>
            <!-- 评分标准表 -->
            <div class="awcloudCup_SorePip">
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_SorePipContent">内容</th>
                    <th class="awcloudCup_SorePipSore">分值</th>
                    <th class="awcloudCup_SorePipRequire">评分要求</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="2" class="awcloudCup_SorePipBac">
                      1.性能指标
                    </td>
                    <td rowspan="2" class="awcloudCup_SorePipBac">40分</td>
                    <td>1.能正确的实现模型部署，并达到帧率(1FPS)要求。30分</td>
                  </tr>
                  <tr>
                    <td>2.FPGA工程时序稳定、结构合理，源码及命名规范。10分</td>
                  </tr>
                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      2.设计完整性
                    </td>
                    <td rowspan="3" class="awcloudCup_SorePipBac">30分</td>
                    <td>1.完整的设计方案。10分</td>
                  </tr>
                  <tr>
                    <td>2.完整的源码工程以及注释。10分</td>
                  </tr>
                  <tr>
                    <td>3.完整的仿真以及测试报告。10分</td>
                  </tr>
                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      3.文档质量
                    </td>
                    <td rowspan="3" class="awcloudCup_SorePipBac">20分</td>
                    <td>1. 汇报PPT重点突出、条理清晰。5分</td>
                  </tr>
                  <tr>
                    <td>2. 设计方案原理分析合理、逻辑清晰。5分</td>
                  </tr>
                  <tr>
                    <td>
                      3、源码规范，注释清晰，仿真以及测试报告详细充分。10分
                    </td>
                  </tr>
                  <tr>
                    <td class="awcloudCup_SorePipBac">4.答辩和现场演示</td>
                    <td class="awcloudCup_SorePipBac">10分</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 按钮 -->
          <!-- <button class="awcloudCup_SorePipEnroll" onclick="javascript:window.open('http://univ.ciciec.com/col.jsp?id=116','_blank')">立即报名海云捷迅杯</button> -->
          <el-row>
            <div
              style="margin: 60px 0; background-color: #ccc"
              class="btn-gwbm"
            >
              报名已结束
            </div>
          </el-row>
        </div>
      </div>
      <el-row class="pd60-0204 sspt-wrapper" id="sspt-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">赛事平台</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="title-text-0204"
            >海云捷迅提供人工智能边缘实验平台作为本次大赛的赛事平台</el-row
          >
          <el-row class="content-col18">
            <div class="content-col18-bg"></div>
            <div>赛事平台-人工智能边缘实验平台</div>
          </el-row>
          <el-row class="font14-0204 mgb10-0204"
            >该平台是由海云捷迅研发的云+FPGA+AI综合性平台</el-row
          >
          <el-row class="content-col14 mgb10-0204">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              云端访问，使用SoC网络技术和FPGA远程调试技术，通过云端向参赛队伍提供服务，参赛队伍可以远程接入此平台，仿真、调试。
            </div>
          </el-row>
          <el-row class="content-col14 mgb10-0204">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              FPGA，自主研发的人工智能边缘实验平台，将多个FPGA板卡放置在同一个机箱中，为其提供电源接口、网络分配管理单元，形成FPGA资源池，板卡使用的C5
              SoC的FPGA。
            </div>
          </el-row>
          <el-row class="content-col14">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              AI，FPGA开发板内置了与百度开源深度学习Paddle-Paddle框架对接的驱动以及FPGA加速器Demo文件，参赛团队可以方便的将模型文件部署到结合Paddle-Paddle框架的FPGA上，
            </div>
          </el-row>
          <el-row class="font14-0204" style="margin-bottom: 30px"
            >测试其效果并调优。</el-row
          >
          <el-row class="sspt-bg-1"> </el-row>
          <el-row class="sspt-bottom clearfix">
            <div>
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>人工智能一体机解决方案</div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">
                  提供人工智能模型训练，用于端到端的实训场景
                </div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">
                  人工智能专业的开箱即用一站式解决方案
                </div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">提供适用的实验与科研环境</div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">提升学生动手操作、项目实践能力</div>
              </el-row>
            </div>
            <div class="sspt-bg-2"></div>
          </el-row>
        </el-row>
      </el-row>
      <el-row class="pd60-0204 yysl-wrapper" id="yysl-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">应用示例</el-row>
          <el-row class="title-bgimg-0204"></el-row>
          <el-row class="title-text-0204"
            >赛事平台应用示例介绍，包括高校应用及产品应用</el-row
          >
          <el-row class="yysl1">
            <div style="margin-right: 95px">
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>高校应用</div>
              </el-row>
              <el-row class="font14-0204 mgb10-0204" style="width: 380px"
                >电子科技大学&nbsp;&nbsp;重庆大学&nbsp;&nbsp;重庆邮电大学&nbsp;&nbsp;重庆交通大学&nbsp;&nbsp;</el-row
              >
            </div>
            <div class="yysl1-img-wrapper">
              <div class="yysl1-img1"></div>
              <div class="yysl1-img2"></div>
              <div class="yysl1-img3"></div>
            </div>
          </el-row>
          <el-row class="yysl1" style="margin-bottom: 0">
            <div style="margin-right: 110px">
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>产品应用</div>
              </el-row>
              <el-row class="font14-0204 mgb10-0204" style="width: 480px"
                >采用赛事平台的Demo工程，基于Mobilenet
                V1-SSD的物体分类模型，提供给参赛团队做参考，发挥同学们的创造力，给参赛团队更大的发挥空间。</el-row
              >
            </div>
            <div class="yysl1-img-wrapper">
              <div class="yysl1-img4"></div>
              <div class="yysl1-img5"></div>
            </div>
          </el-row>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
import Swiper from "@/utils/swiper-bundle.min.js";
export default {
  data() {
    return {
      swiper: null,
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        modules: [Navigation],
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 40,
        navigation: {
          prevEl: ".icon-fj-chevron-left",
          nextEl: ".icon-fj-chevron-right",
          disabledClass: "my-button-disabled",
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "@/less/swiper-bundle.min.css"; // 单独引入swiper样式防止冲突
@import "@/less/awCup.css";// 单独引入样式防止冲突
</style>